import { PropsWithChildren, useMemo } from 'react';

import {
  OrderProvider as BaseOrderProvider,
  OrderProviderProps as BaseOrderProviderProps,
} from 'modules/account/orderModule/common/providers/OrderProvider';

import { OrderContext, OrderContextProps } from './orderContext';

export const OrderProvider = ({
  children,
  order,
  onEnableEdit,
  onDisableEdit,
  onDelete,
  onDownloadOrder,
  ...baseProps
}: OrderContextProps & BaseOrderProviderProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      onEnableEdit,
      onDisableEdit,
      onDelete,
      onDownloadOrder,
    }),
    [onEnableEdit, onDisableEdit, onDelete, onDownloadOrder]
  );

  return (
    <OrderContext.Provider value={value}>
      <BaseOrderProvider
        isDisabledDirectoryFreeSolo
        order={order}
        orderType={order?.operationType}
        {...baseProps}
      >
        {children}
      </BaseOrderProvider>
    </OrderContext.Provider>
  );
};
